// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*,\n*:before,\n*:after {\n  box-sizing: border-box;\n  margin: 0;\n}\nhtml,\nbody {\n  -webkit-text-size-adjust: none !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC',\n    'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif,\n    PingFang-SC-Bold;\n}\n.van-dialog__message {\n  line-height: 0.586667rem !important;\n}", ""]);
// Exports
module.exports = exports;
